import { CertificationStatus } from 'api';

export const getCertificationStatusName = (status: CertificationStatus): string => {
  const statusNames: Record<CertificationStatus, string> = {
    [CertificationStatus.NotYetCertified]: 'Not yet Certified',
    [CertificationStatus.Expired]: 'Expired',
    [CertificationStatus.Suspended]: 'Suspended',
    [CertificationStatus.New]: 'New',
    [CertificationStatus.Withdrawn]: 'Withdrawn',
    [CertificationStatus.Current]: 'Current',
    [CertificationStatus.Inactive]: 'Inactive',
    [CertificationStatus.StandardisationDue]: 'Standardisation due',
    [CertificationStatus.Standardising]: 'Standardising',
    [CertificationStatus.Restricted]: 'Restricted',
  };

  return statusNames[status] ?? '-';
};

export const getCertificationStatusShortCode = (status: CertificationStatus): string => {
  const statusShortCodes: Record<CertificationStatus, string> = {
    [CertificationStatus.NotYetCertified]: 'NotYetCertified',
    [CertificationStatus.Expired]: 'Expired',
    [CertificationStatus.Suspended]: 'Suspended',
    [CertificationStatus.New]: 'New',
    [CertificationStatus.Withdrawn]: 'Withdrawn',
    [CertificationStatus.Current]: 'Current',
    [CertificationStatus.Inactive]: 'Inactive',
    [CertificationStatus.StandardisationDue]: 'StandardisationDue',
    [CertificationStatus.Standardising]: 'Standardising',
    [CertificationStatus.Restricted]: 'Restricted',
  };

  return statusShortCodes[status] ?? '-';
};
